var url = window.location.pathname;
var caminho = url.substring(0, url.indexOf("/app/relatorio/", 0));
//alert(url);
//alert(caminho);
$(document).ready(function () {

    $('#lista-titulo-menu-gerarxls,#lista-titulo-menu-gerarhtml').on('click',function(){
        $('.panel-load').addClass('whirl standard');
        $(this).ladda();
        $(this).ladda('start');

        //var id_elemento     = $(this).attr("id");
        //salvarElemento(id_elemento);

        setTimeout(function(){
            var id_elemento     = $(this).attr("id");
            salvarElemento(id_elemento);
        }, 5000);
    });
});

$(window).on('load', function (){
    if ($('#tableRelatorioAprovacaoExpositorPeriodo').length > 0) {
        $('.container.container-form').addClass('container-relatorio-aprovacao');
    }
});

function salvarElemento(id_elemento){
    var titulo          = $("#lista-titulo-texto").text();

    var cor             = "";
    var background_cor  = "";
    var borda_cima      = "";
    var borda_baixo     = "";
    var borda_esquerda  = "";
    var borda_direita   = "";
    var verticalAlign   = "";
    var textAlign       = "";
    var fontWeight      = "";
    var fontSize        = "";
//        var width           = "";

    $('.tabela-xls tr').each(function(index) {
        cor = ($(this).css('color'));
        background_cor = ($(this).css('background-color'));
        borda_cima = ($(this).css('border-top-width')+ ' '+$(this).css('border-top-style')+ ' '+$(this).css('border-top-color'));
        borda_baixo = ($(this).css('border-bottom-width')+ ' '+$(this).css('border-bottom-style')+ ' '+$(this).css('border-bottom-color'));
        borda_esquerda = ($(this).css('border-left-width')+ ' '+$(this).css('border-left-style')+ ' '+$(this).css('border-left-color'));
        borda_direita = ($(this).css('border-right-width')+ ' '+$(this).css('border-right-style')+ ' '+$(this).css('border-right-color'));
        $(this).css('color',cor);
        $(this).css('background-color',background_cor);
        $(this).css('border-top',borda_cima);
        $(this).css('border-bottom',borda_baixo);
        $(this).css('border-left',borda_esquerda);
        $(this).css('border-right',borda_direita);
    });
    $('.tabela-xls td').each(function(index) {
        cor = ($(this).css('color'));
        background_cor = ($(this).css('background-color'));
        borda_cima = ($(this).css('border-top-width')+ ' '+$(this).css('border-top-style')+ ' '+$(this).css('border-top-color'));
        borda_baixo = ($(this).css('border-bottom-width')+ ' '+$(this).css('border-bottom-style')+ ' '+$(this).css('border-bottom-color'));
        borda_esquerda = ($(this).css('border-left-width')+ ' '+$(this).css('border-left-style')+ ' '+$(this).css('border-left-color'));
        borda_direita = ($(this).css('border-right-width')+ ' '+$(this).css('border-right-style')+ ' '+$(this).css('border-right-color'));
        verticalAlign = ($(this).css('vertical-align'));
        textAlign = ($(this).css('text-align'));
        fontWeight = ($(this).css('font-weight'));
        fontSize = ($(this).css('font-size'));
//            width = ($(this).css('width'));
        if($(this).find('.alert').length > 0){
            cor = ($(this).find('.alert').css('color'));
        }
        $(this).css('color',cor);
        $(this).css('background-color',background_cor);
        $(this).css('border-bottom',borda_baixo);
        $(this).css('border-left',borda_esquerda);
        $(this).css('border-right',borda_direita);
        $(this).css('border-top',borda_cima);
        $(this).css('vertical-align',verticalAlign);
        $(this).css('text-align',textAlign);
        $(this).css('font-weight',fontWeight);
        $(this).css('font-size',fontSize);
//            $(this).css('width',width);
    });
    $('.tabela-xls th').each(function(index) {
        cor = ($(this).css('color'));
        background_cor = ($(this).css('background-color'));
        borda_cima = ($(this).css('border-top-width')+ ' '+$(this).css('border-top-style')+ ' '+$(this).css('border-top-color'));
        borda_baixo = ($(this).css('border-bottom-width')+ ' '+$(this).css('border-bottom-style')+ ' '+$(this).css('border-bottom-color'));
        borda_esquerda = ($(this).css('border-left-width')+ ' '+$(this).css('border-left-style')+ ' '+$(this).css('border-left-color'));
        borda_direita = ($(this).css('border-right-width')+ ' '+$(this).css('border-right-style')+ ' '+$(this).css('border-right-color'));
        textAlign = ($(this).css('text-align'));
        $(this).css('color',cor);
        $(this).css('background-color',background_cor);
        $(this).css('border-top',borda_cima);
        $(this).css('border-bottom',borda_baixo);
        $(this).css('border-left',borda_esquerda);
        $(this).css('border-right',borda_direita);
        $(this).css('text-align',textAlign);
    });
    var html        = $("#gride").contents().clone();
    html.find('.tabela-xls').each(function(index) {
        if ( $(this).css('display') === 'none' ){
            if($(this).prop("tagName") === 'TD'){
                $(this).html('');
            }else{
                $(this).remove();
            }
        }
    });

    var grafico = html.find('.nao-exporta-grafico');
    if (grafico.length > 0){
        grafico.remove();
    }

    var $html       = $('<div>',{html:html}).hide().appendTo('body');
    var html2       = "&nbsp;";
    var cabecalho   = $('table.tabela-xls tr:first').parent().children(":eq(1)");
    cor             = (cabecalho.css('color'));
    background_cor  = (cabecalho.css('background-color'));
    $html.find('.tabela-xls img').remove();

    $html.find('input[type="text"]').each(function() {
        if($(this).hasClass('valor_leitura')){
            $(this).after($(this).val()+'<br/>');
        }else{
            $(this).after('<br/>&nbsp;'+$(this).val());
        }
        $(this).remove();
    });
    $html.find('select').each(function() {
        var id = $(this).attr('id');
        $(this).after($('#'+id).find('option:selected').text());
//            $(this).remove();
    });
    $html.find('textarea').each(function() {
        var id = $(this).attr('id');
        $(this).after($('#'+id).val());
        $(this).remove();
    });
    $html.find('a').each(function() {
        if($(this).text().trim() !== 'Visualizar'){
            $(this).after($(this).html());
        }
        console.log($(this).text().trim());
        $(this).remove();
    });

    html2 = $html.html();

    if(id_elemento === "lista-titulo-menu-gerarhtml"){
        var url_xls = caminho+"/gerarhtml";
    }
    else{
        var url_xls = caminho+"/gerarxls";
    }

    $.post(url_xls,{html  : html2,titulo: titulo},
        function(resposta){
            $('.panel-load').removeClass('whirl standard');
            $('#lista-titulo-menu-gerarxls,#lista-titulo-menu-gerarhtml').ladda('stop');

            window.self.location.href = url_xls;
    });
}